import React from 'react';
import AreaPage from './page';


export const ExperimentsPage = () => <AreaPage titleKey="pages.experiments" area="areaExperiments" />;
